module.exports = __webpack_public_path__ + "img/fridge.2cf103ce.png";